module.exports = __webpack_public_path__ + "img/experience.9dee1b7a.png";